import StoreConnector from '@/helpers/StoreConnector'
import BulkChangeOrderApi from 'api-client/BulkChangeOrder'
import { EventBus } from '@/plugins/event-bus'

const BulkChangeOrderService = {
  async getBulkChangeOrders(page, includeNationWide, searchQuery) {
    try {
      const result = await BulkChangeOrderApi.getBulkChangeOrders(
        page,
        includeNationWide,
        searchQuery
      )
      StoreConnector.dispatch('bulkChangeOrder/setBulkChangeOrders', result)
      return Promise.resolve()
    } catch (e) {
      EventBus.$emit('notification-warning', 'bulkchangeordersgetfailed')
      return Promise.reject(e)
    }
  },
  resetBulkChangeOrders() {
    StoreConnector.dispatch('bulkChangeOrder/resetBulkChangeOrders')
  },
  async getBulkChangeOrderByBulkChangeOrderId(bulkChangeOrderId) {
    try {
      const result =
        await BulkChangeOrderApi.getBulkChangeOrderByBulkChangeOrderId(bulkChangeOrderId)
      StoreConnector.dispatch('bulkChangeOrder/setBulkChangeOrder', result)
    } catch (e) {
      EventBus.$emit('notification-warning', 'bulkchangeeordersgetfailed')
      return null
    }
  },
  async deleteBulkChangeOrder(bulkChangeOrderId) {
    try {
      await BulkChangeOrderApi.deleteBulkChangeOrder(bulkChangeOrderId)
      return Promise.resolve()
    } catch (e) {
      EventBus.$emit('notification-warning', 'De bulk order kon niet worden verwijderd.')
      return Promise.reject(e)
    }
  },
  async pauseBulkChangeOrder(bulkChangeOrderId) {
    try {
      await BulkChangeOrderApi.pauseBulkChangeOrder(bulkChangeOrderId)
      return Promise.resolve()
    } catch (e) {
      EventBus.$emit('notification-warning', 'De bulk order kon niet worden gepauzeerd.')
      return Promise.reject(e)
    }
  },
  async resumeBulkChangeOrder(bulkChangeOrderId) {
    try {
      await BulkChangeOrderApi.resumeBulkChangeOrder(bulkChangeOrderId)
      return Promise.resolve()
    } catch (e) {
      EventBus.$emit('notification-warning', 'De bulk order kon niet worden gestart.')
      return Promise.reject(e)
    }
  },
  async uploadBulkChangeOrder(file) {
    try {
      const bulkChangeOrderResult = await BulkChangeOrderApi.uploadBulkChangeOrder(file)

      await StoreConnector.dispatch('bulkChangeOrder/setBulkChangeOrder', bulkChangeOrderResult)
      return bulkChangeOrderResult
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden')
      return Promise.reject(e)
    }
  },
  async checkBulkChangeOrder(changeOrderId) {
    try {
      await BulkChangeOrderApi.processBulkChangeOrder(changeOrderId, 'MODIFICATION_CHECK')
      EventBus.$emit('notification-success', 'Bulk wijzigingsorder verzonden')
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden')
      return Promise.reject(e)
    }
  },
  async processBulkChangeOrder(changeOrderId) {
    try {
      await BulkChangeOrderApi.processBulkChangeOrder(changeOrderId, 'MODIFICATION')
      EventBus.$emit('notification-success', 'Bulk wijzigingsorder verzonden')
    } catch (e) {
      EventBus.$emit('notification-warning', 'Er is een fout opgetreden')
      return Promise.reject(e)
    }
  },
  async downloadExcelExport(bulkChangeOrderId) {
    await BulkChangeOrderApi.downloadExcelExport(bulkChangeOrderId)
  },
}

export default BulkChangeOrderService
